const serviceContactForm = {
  props: {
    dynamicClass: ".service-contact-form-dl-id.dynamicLoading",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-serviceContactForm.css", this.props.dynamicClass);
  },
};

export default serviceContactForm;
